import { GeographicalDistributionFiling } from "./geographical-filing";
export default GeographicalDistributionFiling;
